<!--
 * @Author: 范向玲
 * @Date: 2022-10-08 16:58:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-24 17:48:06
 * @Description:
 * @FilePath: \web\src\components\DataManagement\tradeQuantity\component\searchLibrary.vue
-->
<template>
  <div class="tradeQuantity-search-library">
    <div class="formItem">
      <!-- <div class="search-item">
        <span>矿种：</span>
        <a-select v-model:value="requestParams.commodity" placeholder="请选择矿种">
          <a-select-option v-for="item in minerals" :key="item.name">
            {{ item.name }}
          </a-select-option>
          <template #suffixIcon>
            <CaretDownOutlined />
          </template>
</a-select>
</div> -->
      <div class="search-item">
        <span>矿种：</span>
        <a-input placeholder="请输入矿种" v-model:value="requestParams.commodity" />
      </div>

      <!-- <div class="search-item">
        <span>数据来源：</span>
        <a-input placeholder="请输入数据来源" v-model:value="requestParams.propName" />
      </div> -->

      <div class="search-item search-item-time">
        <span>时间选择：</span>
        <!-- <a-range-picker  v-model:value="requestParams.reportDate" @change="changeDate"  mode="year" format="YYYY"/> -->
        <a-date-picker format="YYYY" mode="year"
          :value="requestParams.startYear ? moment(requestParams.startYear) : null" :open="open1"
          @openChange="openChange1" @panelChange="(e) => panelChange('startYear', e)"
          @change="(e) => changeYear('startYear', e)" />
        <a-date-picker format="YYYY" mode="year" :value="requestParams.endYear ? moment(requestParams.endYear) : ''"
          :open="open2" @openChange="openChange2" @panelChange="(e) => panelChange('endYear', e)"
          @change="(e) => changeYear('endYear', e)" />
      </div>
    </div>

    <slot name="btns">
      <div class="btn-wrapper" :class="searchType === 'left' ? 'btn-wrapper-left' : ''">
        <div class="reset-btn btn-item search-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch()">查询</div>
      </div>
    </slot>
  </div>
</template>

<script setup>
import * as dayjs from 'dayjs';
import { CaretDownOutlined } from '@ant-design/icons-vue';
import { computed, onMounted, toRefs, ref, defineProps, defineEmits, onBeforeMount, watch } from 'vue';
import { GET_COUNTRYS, GET_REGIONS } from '@/store/modules/actions/projectLibrary';
import { getProjectStages, getDicInfoApi } from '@/api/drillLibrary/utilsApi';
import { getMineralsApi } from '@/api/utils/utilsApi';
import MineralTypeVue from '@/components/ProjectLibrary/main/orenodeSearch/keySearch/mineralType.vue';
import moment from 'moment';
import { useStore } from 'vuex';
const props = defineProps({
  storeModule: {
    type: String,
    default: 'reservesLibrary',
  },
  searchType: {
    type: String,
    default: 'right',
  },
  type:{
    type:String,
    default: 'cl',
  }
});
const open1 = ref(false), open2 = ref(false),
  year = ref(moment());
/**
 * 中资占比
 */
const pctRangeLevel = ref();

const emit = defineEmits(['submit']);

const { storeModule } = toRefs(props);

const { state, dispatch: storeDispatch, commit: storeCommit } = useStore();
// state

const tradeQuantityState = computed(() => state.reservesLibrary);
const { regions, countrys, requestParams } = toRefs(tradeQuantityState.value);

const generalState = computed(() => state.general);
const { minerals, claimTypes, projectSource, rateSource, pctRange } = toRefs(generalState.value);
const openChange1 = (status) => {
  if (status) {
    open1.value = true;
  } else {
    open1.value = false;
  }
};
const openChange2 = (status) => {
  if (status) {
    open2.value = true;
  } else {
    open2.value = false;
  }
};
const panelChange = (name, value) => {
  requestParams.value[name] = moment(value).format('YYYY')
  year.value = value;
  name === 'startYear' ? open1.value = false : open2.value = false
};
const changeYear = (name, value) => {
  requestParams.value[name] = value && moment(value).format('YYYY') || value
  year.value = value;
}
// action
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || storeModule.value}/${methods}`, params);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || storeModule.value}/${methods}`, params);

// ref
const mineralVisible = ref(false);
const mineralTypeVue = ref(null);
const stages = ref(null);
const explorationList = ref(null);
const intervalCommodities = ref(null);


getMineralsApi().then((res) => {
  let list = res.data;

  // list.unshift({ id: null, name: '全部', });
  minerals.value = list;
  intervalCommodities.value = list;
});

/**
 * @description 查询
 */
const submitSearch = () => {
  requestParams.value.page = 1;
  emit('submit', requestParams.value);
};

/**
 * @description 重置
 */
const resetSearch = () => {
  // mineralTypeVue.value.reset();
  commit(null, 'clear');
  submitSearch();
};
// onMounted(()=>{
//   getPrimary();

// })
watch(props.type, (val) => {
  console.log(222)
  resetSearch()
}, {
  immediate: true,
  deep: true,
});
</script>

<style lang="scss">
.tradeQuantity-search-library {
  width: 100%;
  display: block;
  position: relative;

  .formItem {
    display: flex;
    width: 100%;

    flex-wrap: wrap;
    height: 0.51rem;
    padding: 0.13rem 0.1rem;

    .search-item {
      // display: flex;
      align-items: center;
      // display: inline-block;
      width: calc(20% - 0.05rem);
      height: 0.34rem;
      line-height: 0.34rem;
      margin-right: 0.05rem;

      >span {
        display: inline-block;
        height: 100%;
        width: 1.3rem;
        text-align: right;
        font-size: 0.14rem;
      }

      .ant-input,
      .ant-input-number,
      .ant-select {
        display: inline-block;
        width: calc(100% - 1.3rem);
        color: white;
        background-color: transparent;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
        background-color: rgba(91, 76, 39, 0.4);

        &.ant-input-affix-wrapper-foused {
          border: none;
        }

        .ant-select-selection-placeholder,
        .ant-select-selection-item {
          padding-right: 0;
          background: transparent;
          border: 0;

          .anticon {
            color: #fff;
          }
        }

        .ant-select-selector {
          background: transparent;
          border: 0;
        }

        .ant-select-arrow {
          color: #fff;

          .ant-select-suffix {
            width: 0.12rem;
            height: 0.12rem;
            margin-top: .02rem;
          }
        }
      }

      .ant-input-number .ant-input-number-handler-wrap {
        background: rgba(91, 76, 39, 0.4);
        border: .01rem solid rgba(91, 76, 39, 0.4);
      }

      .ant-input-number:hover .ant-input-number-handler-wrap {
        background: rgba(91, 76, 39, 0.4);
        border: .01rem solid rgba(91, 76, 39, 0.4);
      }

      .mineral {
        display: inline-block;
        width: calc(100% - 1.3rem);
        height: 100%;
        position: relative;

        .mineral-type-cascader {
          height: 0.34rem;
          font-size: 0.14rem;
          background-color: rgba(91, 76, 39, 0.4);
          padding-left: 0.11rem;
        }
      }

      .double {
        width: calc(50% - 0.8rem);
        margin: 0 0.05rem;
      }

      .ant-radio-wrapper {
        span {
          color: #fff;
        }
      }

      .ant-calendar-picker {
        width: calc(100% - 1.3rem);
      }

      .ant-calendar-picker-input {
        width: 100%;
      }

      .ant-calendar-picker {
        width: 1rem;
        margin-right: 0.1rem;
      }
    }

    .search-item-time {
      min-width: 4rem
    }
  }

  .btn-wrapper {
    position: absolute;
    right: 0rem;
    bottom: 0.05rem;
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;
    width: 2rem;
    justify-content: flex-end;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
      margin-left: 0.05rem;
    }
  }

  .btn-wrapper-left {
    right: 5rem;
  }
}
</style>
